import React from "react";
import { useReveal, useHover } from "./Hooks";
import {
  RevealWrapper,
  SectionContainer,
  SectionLabel,
  SectionTitle,
  SectionSubtitle,
  SpeakersWrapper,
  SpeakersGrid,
  SpeakerCardWrapper,
  SpeakerImgWrapper,
  SpeakerImg,
  SpeakerImgOverlay,
  SpeakerTagBadge,
  SpeakerInfo,
  SpeakerName,
  SpeakerDesig,
  SpeakerOrg,
} from "../Styles";
import styled from "styled-components";
import { theme } from "../Styles";
import useWebinar from "../../../../hooks/useWebinar";

const SpeakerDescription = styled.p`
  font-family: openSans-Regular, sans-serif;
  font-size: 0.82rem;
  color: ${theme.muted};
  line-height: 1.65;
  margin-top: 0.55rem;
`;

function SpeakerCard({ src, alt, name, designation, org, tag, description }) {
  const { hoverProps } = useHover();

  return (
    <SpeakerCardWrapper {...hoverProps}>
      <SpeakerImgWrapper>
        <SpeakerImg src={src} alt={alt} loading="lazy" />
        <SpeakerImgOverlay />
        {tag && <SpeakerTagBadge>{tag}</SpeakerTagBadge>}
      </SpeakerImgWrapper>

      <SpeakerInfo>
        <SpeakerName>{name}</SpeakerName>
        <SpeakerDesig>{designation}</SpeakerDesig>
        <SpeakerOrg>{org}</SpeakerOrg>
        {description && <SpeakerDescription>{description}</SpeakerDescription>}
      </SpeakerInfo>
    </SpeakerCardWrapper>
  );
}

function SpeakerCardReveal({ speaker, delay }) {
  const { ref, visible } = useReveal(delay);

  return (
    <RevealWrapper ref={ref} $visible={visible}>
      <SpeakerCard {...speaker} />
    </RevealWrapper>
  );
}

function Speakers() {
  const { config } = useWebinar();
  const speakersData = config?.speakers;

  const headingReveal = useReveal(0);
  const titleReveal = useReveal(80);
  const subtitleReveal = useReveal(140);

  if (!speakersData?.show) return null;

  const visibleSpeakers =
    speakersData.items?.filter((speaker) => speaker.show) ?? [];

  return (
    <SpeakersWrapper id="speakers">
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          top: -80,
          right: -80,
          width: 360,
          height: 360,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0,131,140,0.07) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <SectionContainer>
        <RevealWrapper ref={headingReveal.ref} $visible={headingReveal.visible}>
          <SectionLabel>{speakersData.sectionLabel}</SectionLabel>
        </RevealWrapper>

        <RevealWrapper ref={titleReveal.ref} $visible={titleReveal.visible}>
          <SectionTitle>{speakersData.sectionTitle}</SectionTitle>
        </RevealWrapper>

        <RevealWrapper
          ref={subtitleReveal.ref}
          $visible={subtitleReveal.visible}
        >
          <SectionSubtitle>{speakersData.sectionSubtitle}</SectionSubtitle>
        </RevealWrapper>

        <SpeakersGrid>
          {visibleSpeakers.map((speaker, index) => (
            <SpeakerCardReveal
              key={speaker.id}
              speaker={speaker}
              delay={index * 100}
            />
          ))}
        </SpeakersGrid>
      </SectionContainer>
    </SpeakersWrapper>
  );
}

export { Speakers };
